import { useLatestEntity } from '@domain-group/react-hooks'

import useSelector from '@hooks/useSelector'

import type { BillingTypeModel } from '@models/types'

function useBillingType(initEntity: Partial<BillingTypeModel> = {}) {
  // @ts-expect-error TS2322
  const { entity: billingType }: { entity: BillingTypeModel } = useLatestEntity(initEntity, 'billingTypes')

  const { loading } = useSelector(reduxState => reduxState.agents)

  return {
    billingType,
    loading,
  }
}

export default useBillingType
